import { render } from "./CloudCredential.vue?vue&type=template&id=c80d1426"
import script from "./CloudCredential.vue?vue&type=script&lang=js"
export * from "./CloudCredential.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__